import { render, staticRenderFns } from "./AjaxTable.vue?vue&type=template&id=39f414b7&"
import script from "./AjaxTable.vue?vue&type=script&lang=js&"
export * from "./AjaxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports